import React, { useEffect } from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  HStack,
  Image,
  Button,
  SimpleGrid,
  Container,
  Badge,
  Icon,
  Divider,
  Flex,
} from "@chakra-ui/react";
import {
  FiBook,
  FiAward,
  FiShield,
  FiTruck,
  FiUsers,
  FiCheckCircle,
  FiArrowRight,
} from "react-icons/fi";
import { Link } from "react-router-dom";

function Abouts() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box bg="#F8FAFC" minH="100vh">
      {/* Hero Banner Section */}
      <Box
        bgGradient="linear(to-b, #0B132B, #162237)"
        color="white"
        py={{ base: 14, md: 20 }}
        px={{ base: 4, md: 8 }}
        textAlign="center"
      >
        <Container maxW="900px">
          <Badge
            bg="whiteAlpha.200"
            color="#EAB308"
            px={3}
            py={1}
            rounded="full"
            fontSize="xs"
            fontWeight="bold"
            letterSpacing="wider"
            mb={4}
          >
            ⚖️ NAVNEET LAW STUDIOS • ESTABLISHED REPUTATION
          </Badge>

          <Heading
            as="h1"
            fontSize={{ base: "32px", md: "48px" }}
            fontWeight="extrabold"
            letterSpacing="tight"
            lineHeight="shorter"
            mb={4}
          >
            Empowering the Legal Fraternity Across India
          </Heading>

          <Text
            fontSize={{ base: "sm", md: "lg" }}
            color="gray.300"
            maxW="750px"
            mx="auto"
            lineHeight="tall"
          >
            Navneet Law Studio is India's premier destination for authoritative legal literature, bare acts, law journals, and next-generation legal research software.
          </Text>
        </Container>
      </Box>

      {/* Main Narrative & Brand Story */}
      <Container maxW="1200px" py={{ base: 8, md: 16 }} px={{ base: 4, md: 6 }}>
        <Box
          bg="white"
          rounded="2xl"
          border="1px solid"
          borderColor="gray.200"
          shadow="sm"
          p={{ base: 6, md: 10 }}
          mb={12}
        >
          <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={{ base: 8, lg: 12 }} align="center">
            <Box>
              <Badge colorScheme="purple" fontSize="xs" px={2.5} py={0.5} rounded="md" mb={2}>
                OUR MISSION & VISION
              </Badge>
              <Heading as="h2" size="xl" color="#162237" fontWeight="extrabold" mb={4}>
                Your Complete Partner in Modern Legal Practice
              </Heading>
              <Text fontSize="sm" color="gray.600" lineHeight="tall" mb={4}>
                Founded on the cornerstone of reliability and scholarship, Navneet Law Studio provides advocates, corporate legal counsels, judges, law students, and academic institutions with prompt access to essential jurisprudence.
              </Text>
              <Text fontSize="sm" color="gray.600" lineHeight="tall" mb={6}>
                We combine the timeless depth of hardbound judicial commentaries with state-of-the-art SaaS intelligence — delivering Supreme Court and High Court judgments, translation suites, and litigation practice tools directly to your chamber.
              </Text>

              <HStack spacing={4}>
                <Link to="/products?maincat=Books">
                  <Button
                    size="md"
                    bg="#162237"
                    color="white"
                    _hover={{ bg: "#0F172A" }}
                    rounded="lg"
                    rightIcon={<FiArrowRight />}
                  >
                    Browse Literature
                  </Button>
                </Link>
                <Link to="/software">
                  <Button
                    size="md"
                    variant="outline"
                    borderColor="#162237"
                    color="#162237"
                    _hover={{ bg: "gray.100" }}
                    rounded="lg"
                  >
                    Explore Softwares
                  </Button>
                </Link>
              </HStack>
            </Box>

            <Box textAlign="center">
              <Box
                p={3}
                bg="#F1F5F9"
                rounded="2xl"
                border="1px solid"
                borderColor="gray.200"
                display="inline-block"
              >
                <Image
                  src="./law.jpg"
                  alt="Navneet Law Studio Legal Literature"
                  maxH="340px"
                  rounded="xl"
                  objectFit="cover"
                  fallbackSrc="https://navneetlawstudio.com/logo.png"
                />
              </Box>
            </Box>
          </SimpleGrid>
        </Box>

        {/* Why Choose Us Section */}
        <Box mb={16}>
          <Box textAlign="center" mb={10}>
            <Text fontSize="xs" fontWeight="bold" color="#EAB308" textTransform="uppercase" letterSpacing="wider">
              Service Pillars
            </Text>
            <Heading size="xl" color="#162237" fontWeight="extrabold" mt={1}>
              Why Legal Minds Trust Navneet Law Studio
            </Heading>
          </Box>

          <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={6}>
            <Box bg="white" p={6} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
              <Flex w="48px" h="48px" rounded="lg" bg="blue.50" color="#162237" align="center" justify="center" mb={4} fontSize="22px">
                <FiBook />
              </Flex>
              <Heading size="sm" color="#162237" mb={2}>
                Exhaustive Selection
              </Heading>
              <Text fontSize="xs" color="gray.600" lineHeight="tall">
                From Bare Acts, Criminal Manuals, Civil Procedure Codes to leading Taxmann and Supreme Today commentaries.
              </Text>
            </Box>

            <Box bg="white" p={6} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
              <Flex w="48px" h="48px" rounded="lg" bg="green.50" color="green.700" align="center" justify="center" mb={4} fontSize="22px">
                <FiShield />
              </Flex>
              <Heading size="sm" color="#162237" mb={2}>
                100% Genuine Editions
              </Heading>
              <Text fontSize="xs" color="gray.600" lineHeight="tall">
                Direct publisher partnerships guaranteeing authentic printings, official volume pages, and verified editorial notes.
              </Text>
            </Box>

            <Box bg="white" p={6} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
              <Flex w="48px" h="48px" rounded="lg" bg="orange.50" color="#fb641b" align="center" justify="center" mb={4} fontSize="22px">
                <FiTruck />
              </Flex>
              <Heading size="sm" color="#162237" mb={2}>
                Rapid Dispatch Across India
              </Heading>
              <Text fontSize="xs" color="gray.600" lineHeight="tall">
                Carefully packaged in weather-resistant protective wraps and dispatched through reliable courier networks.
              </Text>
            </Box>

            <Box bg="white" p={6} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
              <Flex w="48px" h="48px" rounded="lg" bg="purple.50" color="purple.700" align="center" justify="center" mb={4} fontSize="22px">
                <FiUsers />
              </Flex>
              <Heading size="sm" color="#162237" mb={2}>
                Dedicated Support
              </Heading>
              <Text fontSize="xs" color="gray.600" lineHeight="tall">
                Specialized customer service for chamber subscriptions, bulk institution orders, and custom software setups.
              </Text>
            </Box>
          </SimpleGrid>
        </Box>

        {/* Founder & Leadership Section */}
        <Box
          bg="white"
          rounded="2xl"
          border="1px solid"
          borderColor="gray.200"
          shadow="sm"
          p={{ base: 6, md: 10 }}
        >
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 8, md: 12 }} align="center">
            <Box textAlign="center">
              <Box
                p={2}
                bg="#F1F5F9"
                rounded="2xl"
                border="1px solid"
                borderColor="gray.200"
                display="inline-block"
              >
                <Image
                  src="./navneet-amrute.jpeg"
                  alt="Navneet Amrate - Founder & Director"
                  maxH="340px"
                  rounded="xl"
                  objectFit="contain"
                  fallbackSrc="https://navneetlawstudio.com/logo.png"
                />
              </Box>
            </Box>

            <Box>
              <Badge colorScheme="blue" fontSize="xs" px={2.5} py={0.5} rounded="md" mb={2}>
                FOUNDER & DIRECTOR
              </Badge>
              <Heading as="h3" size="xl" color="#162237" fontWeight="extrabold" mb={1}>
                Navneet Amrate
              </Heading>
              <Text fontSize="sm" color="#EAB308" fontWeight="bold" mb={4}>
                Visionary Behind Navneet Law Studio
              </Text>

              <Text fontSize="sm" color="gray.600" lineHeight="tall" mb={4}>
                Under his leadership, Navneet Law Studio has grown from a specialized law bookstore into a multifaceted legal tech and knowledge enterprise. His dedication to transparency, speed, and customer-first service drives the organization's mission every day.
              </Text>

              <VStack spacing={2} align="stretch" pt={2} borderTop="1px solid" borderColor="gray.100">
                <HStack spacing={2} fontSize="xs" color="gray.700">
                  <Icon as={FiCheckCircle} color="green.600" />
                  <Text>Integrity and fairness in every transaction</Text>
                </HStack>
                <HStack spacing={2} fontSize="xs" color="gray.700">
                  <Icon as={FiCheckCircle} color="green.600" />
                  <Text>Technological modernization of legal workflows</Text>
                </HStack>
                <HStack spacing={2} fontSize="xs" color="gray.700">
                  <Icon as={FiCheckCircle} color="green.600" />
                  <Text>Uncompromising quality and customer care</Text>
                </HStack>
              </VStack>
            </Box>
          </SimpleGrid>
        </Box>
      </Container>
    </Box>
  );
}

export default Abouts;

